export default class {
    constructor() {
        this.clear();
    }

    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    any() {
        return Object.keys(this.errors).length > 0;
    }

    get(field) {
        if (this.errors[field])
            return this.errors[field][0];
    }

    apply(errors) {
        this.clear();
        Object.assign(this.errors, errors);
    }

    clear() {
        this.errors = {};
    }
}
